export const getNameAlignment = (index: number, maxLength: number) => {
  if (index % maxLength === 0) {
    return 'left';
  }
  if ((index + 1) % maxLength === 0) {
    return 'right';
  }
  return 'center';
};

export const getNameAlignmentVerticalOrderedGrid = (
  index: number,
  isMobile: boolean,
  numOfColumns: number,
) => {
  const numOfRightAlign: number = isMobile ? numOfColumns * 5 - 6 : numOfColumns * 4 - 5;

  if (isMobile && index < 5) {
    return 'left';
  }

  if (!isMobile && index < 4) {
    return 'left';
  }

  if (index > numOfRightAlign) {
    return 'right';
  }

  return 'center';
};
